import { render, staticRenderFns } from "./ForgetModal.vue?vue&type=template&id=9856d39c"
import script from "./ForgetModal.vue?vue&type=script&lang=js"
export * from "./ForgetModal.vue?vue&type=script&lang=js"
import style0 from "./ForgetModal.vue?vue&type=style&index=0&id=9856d39c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports